export default class Error {
  message = null
  code = null
  data = null
  itemId = null
}
